
<script>
import { layoutMethods, eloadDashboardMethods, eloadDashboardComputed, dashboardKankolekMethods, dashboardKankolekComputed } from "@/state/helpers";
const { Tooltip } = require('bootstrap');
import moment from 'moment';

export default {
  page: {
    title: "Dashboard",
  },
  components: {
  },
  data() {
    return {
      tooltips: {},
      comingSoonOverlay: false, // Set to true to enable overlay
      isLoading: true,
    };
  },
  computed: {
    ...eloadDashboardComputed,
    ...dashboardKankolekComputed,
    
    // Date labels for header cards (full month name)
    currentMonthLabel() {
      return moment().format('MMMM YYYY');
    },
    priorMonthLabel() {
      return moment().subtract(1, 'month').format('MMMM YYYY');
    },
    currentDateRange() {
      return `${moment().format('MMMM 1')} - ${moment().subtract(1, 'day').format('D, YYYY')}`;
    },
    priorMonthDateRange() {
      const startOfMonth = moment().subtract(1, 'month').startOf('month');
      const currentDay = moment().date();
      const endDate = startOfMonth.clone().add(currentDay - 1, 'days');
      return `${startOfMonth.format('MMMM 1')} - ${endDate.format('D, YYYY')}`;
    },
    
    // Date labels for Period View table (abbreviated month)
    periodViewPriorMonthLabel() {
      return moment().subtract(1, 'month').format('MMM YYYY');
    },
    periodViewPriorMonthDateRange() {
      const startOfMonth = moment().subtract(1, 'month').startOf('month');
      const currentDay = moment().date();
      const endDate = startOfMonth.clone().add(currentDay - 1, 'days');
      return `${startOfMonth.format('MMM D')} - ${endDate.subtract(1, 'day').format('D')}`;
    },
    periodViewCurrentDateRange() {
      return `${moment().format('MMM 1')} - ${moment().subtract(1, 'day').format('D')}`;
    },
    
    // Total Revenue (E-load + Kankolek)
    totalRevenueAmount() {
      return this.calculateB2BLoadIn('MTD') + this.calculateRetailLoadIn('MTD') + this.calculateKankolekRevenue('MTD');
    },
    totalRevenuePMMTD() {
      return this.calculateB2BLoadIn('PMMTD') + this.calculateRetailLoadIn('PMMTD') + this.calculateKankolekRevenue('PMMTD');
    },
    totalRevenueChange() {
      return this.calculateMarginPercentage(this.totalRevenueAmount, this.totalRevenuePMMTD);
    },
    eloadRevenueAmount() {
      return this.calculateB2BLoadIn('MTD') + this.calculateRetailLoadIn('MTD');
    },
    eloadRevenuePMMTD() {
      return this.calculateB2BLoadIn('PMMTD') + this.calculateRetailLoadIn('PMMTD');
    },
    eloadRevenueChange() {
      return this.calculateMarginPercentage(this.eloadRevenueAmount, this.eloadRevenuePMMTD);
    },
    kankolekRevenueAmount() {
      return this.calculateKankolekRevenue('MTD');
    },
    kankolekRevenuePMMTD() {
      return this.calculateKankolekRevenue('PMMTD');
    },
    kankolekRevenueChange() {
      return this.calculateMarginPercentage(this.kankolekRevenueAmount, this.kankolekRevenuePMMTD);
    },
    
    // Total CM1 (E-load + Kankolek)
    totalCM1Amount() {
      return this.calculateB2BCM1('MTD') + this.calculateRetailCM1('MTD') + this.calculateKankolekCM1('MTD');
    },
    totalCM1PMMTD() {
      return this.calculateB2BCM1('PMMTD') + this.calculateRetailCM1('PMMTD') + this.calculateKankolekCM1('PMMTD');
    },
    totalCM1Change() {
      return this.calculateMarginPercentage(this.totalCM1Amount, this.totalCM1PMMTD);
    },
    eloadCM1Amount() {
      return this.calculateB2BCM1('MTD') + this.calculateRetailCM1('MTD');
    },
    eloadCM1PMMTD() {
      return this.calculateB2BCM1('PMMTD') + this.calculateRetailCM1('PMMTD');
    },
    eloadCM1Change() {
      return this.calculateMarginPercentage(this.eloadCM1Amount, this.eloadCM1PMMTD);
    },
    kankolekCM1Amount() {
      return this.calculateKankolekCM1('MTD');
    },
    kankolekCM1PMMTD() {
      return this.calculateKankolekCM1('PMMTD');
    },
    kankolekCM1Change() {
      return this.calculateMarginPercentage(this.kankolekCM1Amount, this.kankolekCM1PMMTD);
    },
    
    // Total CM2 (E-load + Kankolek)
    totalCM2Amount() {
      return this.calculateB2BCM2('MTD') + this.calculateRetailCM2('MTD') + this.calculateKankolekCM2('MTD');
    },
    totalCM2PMMTD() {
      return this.calculateB2BCM2('PMMTD') + this.calculateRetailCM2('PMMTD') + this.calculateKankolekCM2('PMMTD');
    },
    totalCM2Change() {
      return this.calculateMarginPercentage(this.totalCM2Amount, this.totalCM2PMMTD);
    },
    eloadCM2Amount() {
      return this.calculateB2BCM2('MTD') + this.calculateRetailCM2('MTD');
    },
    eloadCM2PMMTD() {
      return this.calculateB2BCM2('PMMTD') + this.calculateRetailCM2('PMMTD');
    },
    eloadCM2Change() {
      return this.calculateMarginPercentage(this.eloadCM2Amount, this.eloadCM2PMMTD);
    },
    kankolekCM2Amount() {
      return this.calculateKankolekCM2('MTD');
    },
    kankolekCM2PMMTD() {
      return this.calculateKankolekCM2('PMMTD');
    },
    kankolekCM2Change() {
      return this.calculateMarginPercentage(this.kankolekCM2Amount, this.kankolekCM2PMMTD);
    },
    
    // CM1 Percentage
    cm1PercentageMTD() {
      return this.totalRevenueAmount > 0 ? (this.totalCM1Amount / this.totalRevenueAmount) * 100 : 0;
    },
    cm1PercentagePMMTD() {
      return this.totalRevenuePMMTD > 0 ? (this.totalCM1PMMTD / this.totalRevenuePMMTD) * 100 : 0;
    },
    
    // CM2 Percentage
    cm2PercentageMTD() {
      return this.totalRevenueAmount > 0 ? (this.totalCM2Amount / this.totalRevenueAmount) * 100 : 0;
    },
    cm2PercentagePMMTD() {
      return this.totalRevenuePMMTD > 0 ? (this.totalCM2PMMTD / this.totalRevenuePMMTD) * 100 : 0;
    },
    
    // Period View - Prior Month (PM)
    eloadRevenuePM() {
      return this.calculateB2BLoadIn('PM') + this.calculateRetailLoadIn('PM');
    },
    kankolekRevenuePM() {
      return this.calculateKankolekRevenue('PM');
    },
    totalRevenuePM() {
      return this.eloadRevenuePM + this.kankolekRevenuePM;
    },
    eloadCM1PM() {
      return this.calculateB2BCM1('PM') + this.calculateRetailCM1('PM');
    },
    kankolekCM1PM() {
      return this.calculateKankolekCM1('PM');
    },
    totalCM1PM() {
      return this.eloadCM1PM + this.kankolekCM1PM;
    },
    eloadCM2PM() {
      return this.calculateB2BCM2('PM') + this.calculateRetailCM2('PM');
    },
    kankolekCM2PM() {
      return this.calculateKankolekCM2('PM');
    },
    totalCM2PM() {
      return this.eloadCM2PM + this.kankolekCM2PM;
    },
    
    // Tooltip data
    tooltipData() {
      return {
        revenue: { title: 'PM MTD', content: this.formatDashboardValue(this.totalRevenuePMMTD) },
        cm1: { title: 'PM MTD', content: this.formatDashboardValue(this.totalCM1PMMTD) },
        cm2: { title: 'PM MTD', content: this.formatDashboardValue(this.totalCM2PMMTD) }
      };
    },
    
    // Determine unified scale for ALL dashboard values
    // Based on the highest value across Revenue, CM1, CM2 (PM, PMMTD, MTD)
    dashboardScale() {
      const allValues = [
        // Revenue
        this.totalRevenueAmount,
        this.totalRevenuePMMTD,
        this.totalRevenuePM,
        this.eloadRevenueAmount,
        this.eloadRevenuePMMTD,
        this.eloadRevenuePM,
        this.kankolekRevenueAmount,
        this.kankolekRevenuePMMTD,
        this.kankolekRevenuePM,
        // CM1
        this.totalCM1Amount,
        this.totalCM1PMMTD,
        this.totalCM1PM,
        this.eloadCM1Amount,
        this.eloadCM1PMMTD,
        this.eloadCM1PM,
        this.kankolekCM1Amount,
        this.kankolekCM1PMMTD,
        this.kankolekCM1PM,
        // CM2
        this.totalCM2Amount,
        this.totalCM2PMMTD,
        this.totalCM2PM,
        this.eloadCM2Amount,
        this.eloadCM2PMMTD,
        this.eloadCM2PM,
        this.kankolekCM2Amount,
        this.kankolekCM2PMMTD,
        this.kankolekCM2PM
      ];
      
      // Find the highest absolute value
      const maxValue = Math.max(...allValues.map(val => Math.abs(val || 0)));
      
      // Determine scale: 'M' for millions, 'K' for thousands, '' for hundreds
      if (maxValue >= 1000000) return 'M';
      if (maxValue >= 1000) return 'K';
      return ''; // hundreds
    },
  },
  
  methods: {
    ...layoutMethods,
    ...eloadDashboardMethods,
    ...dashboardKankolekMethods,

    handleEmailRedirect() {
      try {
        var email_action = JSON.parse(localStorage.getItem("email_action"));
        if (email_action == null) return;
        localStorage.removeItem('email_action');

        if (Object.prototype.hasOwnProperty.call(email_action, "module") && email_action["token"]) {
          switch (email_action["module"]) {
            case "gbitsTopup":
              this.$nextTick(() => {
                this.$router.push({
                  name: "GBITS Topup Request Details",
                  params: { refNo: email_action["token"] }
                });
              });
              break;
            case "eloadB2b":
              this.$nextTick(() => {
                this.$router.push({
                  name: "Eload B2B Request details",
                  params: { refNo: email_action["token"] }
                });
              });
              break;
            default:
              break;
          }
        }
      } catch (error) {
        console.log("handleEmailRedirect error:", error);
      }
    },
    
    // Helper functions to calculate values based on period
    calculateB2BLoadIn(period) {
      const key = `b2bLoadIn${period}`;
      return this.eloadSummary[key] || 0;
    },
    calculateRetailLoadIn(period) {
      const key = `retailLoadIn${period}`;
      return this.eloadSummary[key] || 0;
    },
    calculateB2BCM1(period) {
      const key = `b2bCM1${period}`;
      return this.eloadSummary[key] || 0;
    },
    calculateRetailCM1(period) {
      const key = `retailCM1${period}`;
      return this.eloadSummary[key] || 0;
    },
    calculateB2BCM2(period) {
      const key = `b2bCM2${period}`;
      return this.eloadSummary[key] || 0;
    },
    calculateRetailCM2(period) {
      const key = `retailCM2${period}`;
      return this.eloadSummary[key] || 0;
    },
    
    // Kankolek calculation helper methods
    // Revenue = total_incoming_mdr + total_incoming_convenience_fee + total_eload_sc + total_outgoing_transfer_fee
    calculateKankolekRevenue(period) {
      let data;
      if (period === 'MTD') {
        data = this.kankolekDashboardSummary?.currentMonth;
      } else if (period === 'PMMTD') {
        data = this.kankolekDashboardSummary?.pmtd;
      } else if (period === 'PM') {
        data = this.kankolekDashboardSummary?.previousMonth;
      }

      if (!data) return 0;

      return (data.total_incoming_mdr || 0) +
             (data.total_incoming_convenience_fee || 0) +
             (data.total_eload_sc || 0) +
             (data.total_outgoing_transfer_fee || 0);
    },

    // CM1 = same as Revenue (kankolek_index.vue CM1 card uses totalCurrentRevenue)
    calculateKankolekCM1(period) {
      let data;
      if (period === 'MTD') {
        data = this.kankolekDashboardSummary?.currentMonth;
      } else if (period === 'PMMTD') {
        data = this.kankolekDashboardSummary?.pmtd;
      } else if (period === 'PM') {
        data = this.kankolekDashboardSummary?.previousMonth;
      }

      if (!data) return 0;

      return (data.total_incoming_mdr || 0) +
             (data.total_incoming_convenience_fee || 0) +
             (data.total_eload_sc || 0) +
             (data.total_outgoing_transfer_fee || 0);
    },

    // CM2: deduct merchant/netbank shares per component then sum
    calculateKankolekCM2(period) {
      let data;
      if (period === 'MTD') {
        data = this.kankolekDashboardSummary?.currentMonth;
      } else if (period === 'PMMTD') {
        data = this.kankolekDashboardSummary?.pmtd;
      } else if (period === 'PM') {
        data = this.kankolekDashboardSummary?.previousMonth;
      }

      if (!data) return 0;

      const kolekCm2 = (data.total_incoming_convenience_fee || 0) - (data.total_incoming_merchant_share || 0) - (data.prev_incoming_kf_netbank_share || 0);
      const mdrCm2 = (data.total_incoming_mdr || 0) - (data.prev_incoming_mdr_netbank_share || 0);
      const transferCm2 = (data.total_outgoing_transfer_fee || 0) - (data.prev_outgoing_netbank_share || 0);

      return kolekCm2 + mdrCm2 + transferCm2;
    },
    
    // Calculate margin percentage (Growth %)
    calculateMarginPercentage(mtd, pmMTD) {
      const currentValue = mtd || 0;
      const previousValue = pmMTD || 0;
      
      if (currentValue === 0 && previousValue === 0) return 0;
      if (previousValue === 0) return 0;
      
      return ((currentValue / previousValue) - 1) * 100;
    },
    
    // Format value for dashboard using unified scale (without ₱ prefix)
    formatDashboardValue(value) {
      const scale = this.dashboardScale;
      
      // Handle zero values based on scale
      if (value === 0 || !value) {
        if (scale === 'M') return '0M';
        if (scale === 'K') return '0K';
        return '0';
      }
      
      const absValue = Math.abs(value);
      
      if (scale === 'M') {
        // Millions scale: convert K to 0M, M to M
        if (absValue < 1000000) {
          return '0M';
        }
        return Math.floor(value / 1000000) + 'M';
      } else if (scale === 'K') {
        // Thousands scale: convert hundreds to 0K, K to K
        if (absValue < 1000) {
          return '0K';
        }
        return Math.floor(value / 1000) + 'K';
      } else {
        // Hundreds scale: show as is
        return Math.round(value).toString();
      }
    },
    
    // Format number for Period View table using unified scale
    formatNumber(number) {
      const scale = this.dashboardScale;
      
      // Handle zero values based on scale
      if (number === 0 || !number) {
        if (scale === 'M') return '0M';
        if (scale === 'K') return '0K';
        return '0';
      }
      
      const absNumber = Math.abs(number);
      
      if (scale === 'M') {
        // Millions scale: convert K to 0M, M to M
        if (absNumber < 1000000) {
          return '0M';
        }
        return Math.floor(number / 1000000) + 'M';
      } else if (scale === 'K') {
        // Thousands scale: convert hundreds to 0K, K to K
        if (absNumber < 1000) {
          return '0K';
        }
        return Math.floor(number / 1000) + 'K';
      } else {
        // Hundreds scale: show as is
        return Math.round(number).toString();
      }
    },
    
    // Get complete value for tooltip (no decimals)
    getCompleteValue(value) {
      // Show ₱0 for zero values
      return new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value || 0);
    },
    
    // Format tooltip text with "PM MTD" label on top and complete value on bottom
    formatTooltip(value) {
      const completeValue = this.getCompleteValue(value);
        return `
          <div class="dashboard-tooltip-content">
            <div class="dashboard-tooltip-title">PM MTD</div>
            <div class="dashboard-tooltip-value">${completeValue}</div>
          </div>
        `;
    },
    
    // Format tooltip for Period View table - just shows the complete value
    formatTableTooltip(value) {
      return this.getCompleteValue(value);
    },
    
    getPercentageClass(value) {
      if (value === 0) return 'text-neutral';
      if (value > 0) return 'text-success';
      if (value < 0) return 'text-danger';
      return 'text-muted';
    },
    
    /**
     * Initialize all tooltips using data from this.tooltipData
     */
    initializeAllTooltips() {
      // Initialize all Bootstrap tooltips
      this.$nextTick(() => {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
          // we need to dispose existing tooltip to avoid duplicate
          const existingTooltip = Tooltip.getInstance(tooltipTriggerEl);
          if (existingTooltip) {
            existingTooltip.dispose();
          }
          
          // we'll get the placement 
          const placement = tooltipTriggerEl.getAttribute('data-bs-placement') || 'top';
          
          new Tooltip(tooltipTriggerEl, {
            html: true,
            placement: placement,
            customClass: 'dashboard-tooltip-left' // for just alignment text
          });
        });
      });
    }
  },
  async mounted() {
    this.changeTitle({ title: "Dashboard" });

    // Handle email action redirect (e.g. from approval notification emails)
    this.handleEmailRedirect();
    
    // Load eload summary data
    this.isLoading = true;
    try {
      // Load eload summary
      await this.getELoadSummary();
      
      // Load kankolek summary
      await this.actionDashboardKankolek({
        action: 'summary',
        body: {}
      });
      
      // Initialize tooltips after data is loaded
      this.$nextTick(() => {
        this.initializeAllTooltips();
      });
    } catch (error) {
      console.error('Error loading dashboard data:', error);
    } finally {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    // Cleanup all tooltips when component is destroyed
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
      const tooltip = Tooltip.getInstance(tooltipTriggerEl);
      if (tooltip) {
        tooltip.dispose();
      }
    });
  },
};
</script>

<template>
  <div class="container-fluid">
    <!-- Coming Soon Overlay -->
    <div v-if="comingSoonOverlay" class="coming-soon-overlay">
      <div class="coming-soon-content">
        <div class="text-center">
          <i class="fas fa-chart-line fa-4x mb-4 text-primary"></i>
          <h2 class="fw-bold text-dark mb-3">Coming Soon</h2>
          <p class="text-muted mb-0">This Dashboard is under development and will be available soon.</p>
        </div>
      </div>
    </div>
    
    <!-- Header Cards -->
    <div class="row g-3 mb-4">
      <!-- Total Revenue Card -->
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 border-0 shadow-sm position-relative card-stat">
          <div class="card-body">
            <h6 class="card-title mb-3 dashboard-card-title">Total Revenue</h6>
            <div class="d-flex align-items-center">
              <h3 
                class="mb-0 me-2 text-dark fw-bold" 
              >
                <span class="peso-sign-gray">₱</span>{{ formatDashboardValue(totalRevenueAmount) }}
              </h3>
            <span
                id="revenue-percentage"
                :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded px-2 py-1', getPercentageClass(totalRevenueChange), 'bg-opacity-75']"
                :style="{ borderRadius: '4px', background: totalRevenueChange === 0 ? '#F9F9F9' : (totalRevenueChange > 0 ? 'var(--Success-Success-Light, #E8FFF3)' : 'var(--Danger-Danger-Light, #FFE8E8)') }"
                data-bs-toggle="tooltip" 
                data-bs-placement="right" 
                :title="formatTooltip(totalRevenuePMMTD)"
            >
                <svg  v-if="totalRevenueChange > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                    <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                </svg>

                <svg v-else-if="totalRevenueChange < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                    <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                </svg>
                {{ Math.abs(totalRevenueChange).toFixed(1) }}%
            </span>
            </div>
            <p class="small mb-3 dashboard-date-text">{{ currentDateRange }}</p>
            
            <div class="border-top pt-3 mt-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium dashboard-label-text">E-Load</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold me-2 text-dark"
                  >
                    ₱{{ formatDashboardValue(eloadRevenueAmount) }}
                  </span>
                <span
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small cursor-pointer', getPercentageClass(eloadRevenueChange)]"
                     data-bs-toggle="tooltip" 
                    data-bs-placement="right" 
                    :title="formatTooltip(eloadRevenuePMMTD)"
                >
                    <svg v-if="eloadRevenueChange > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                        <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>

                    <svg v-else-if="eloadRevenueChange < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                        <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 3.96Z" fill="#D9214E"/>
                    </svg>

                    {{ Math.abs(eloadRevenueChange).toFixed(1) }}%
                </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium dashboard-label-text">Kankolek</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold me-2 text-dark"
                  >
                    ₱{{ formatDashboardValue(kankolekRevenueAmount) }}
                  </span>
                <span
                    :class="['small fw-medium d-inline-flex align-items-center percentage-badge-small cursor-pointer', getPercentageClass(kankolekRevenueChange)]"
                     data-bs-toggle="tooltip" 
                    data-bs-placement="right" 
                    :title="formatTooltip(kankolekRevenuePMMTD)"
                >
                    <svg v-if="kankolekRevenueChange > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                        <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>

                    <svg v-else-if="kankolekRevenueChange < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                        <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 0Z" fill="#D9214E"/>
                    </svg>
                    {{ Math.abs(kankolekRevenueChange).toFixed(1) }}%
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Total CM1 Card -->
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 border-0 shadow-sm position-relative card-stat">
          <div class="card-body">
            <h6 class="card-title mb-3 dashboard-card-title">Total CM1</h6>
            <div class="d-flex align-items-center">
              <h3 
                class="mb-0 me-2 text-dark fw-bold" 
              >
                <span class="peso-sign-gray">₱</span>{{ formatDashboardValue(totalCM1Amount) }}
              </h3>
            <span
                id="cm1-percentage"
                :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded px-2 py-1', getPercentageClass(totalCM1Change), 'bg-opacity-75']"
                :style="{ borderRadius: '4px', background: totalCM1Change === 0 ? '#F9F9F9' : (totalCM1Change > 0 ? 'var(--Success-Success-Light, #E8FFF3)' : 'var(--Danger-Danger-Light, #FFE8E8)') }"
                data-bs-toggle="tooltip" 
                data-bs-placement="right" 
                :title="formatTooltip(totalCM1PMMTD)"
            >
                <svg v-if="totalCM1Change > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                    <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                </svg>
                <svg v-else-if="totalCM1Change < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                    <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                </svg>
                {{ Math.abs(totalCM1Change).toFixed(1) }}%
              </span>
            </div>
            <p class="small mb-3 dashboard-date-text">{{ currentDateRange }}</p>
            
            <div class="border-top pt-3 mt-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium dashboard-label-text">E-Load</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold me-2 text-dark "
                    
                  >
                    ₱{{ formatDashboardValue(eloadCM1Amount) }}
                  </span>
                <span
                    :class="['small fw-medium d-inline-flex align-items-center percentage-badge-small cursor-pointer', getPercentageClass(eloadCM1Change)]"
                    data-bs-toggle="tooltip" 
                    data-bs-placement="right" 
                    :title="formatTooltip(eloadCM1PMMTD)"
                >
                    <svg v-if="eloadCM1Change > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                        <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>

                    <svg v-else-if="eloadCM1Change < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                        <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 0Z" fill="#D9214E"/>
                    </svg>

                    {{ Math.abs(eloadCM1Change).toFixed(1) }}%
                </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium dashboard-label-text">Kankolek</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold me-2 text-dark"
                  >
                    ₱{{ formatDashboardValue(kankolekCM1Amount) }}
                  </span>
                    <span
                        :class="['small fw-medium d-inline-flex align-items-center percentage-badge-small cursor-pointer', getPercentageClass(kankolekCM1Change)]"
                        data-bs-toggle="tooltip" 
                        data-bs-placement="right" 
                        :title="formatTooltip(kankolekCM1PMMTD)"
                    >
                        <svg v-if="kankolekCM1Change > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                            <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                            <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                        </svg>

                        <svg v-else-if="kankolekCM1Change < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                            <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                            <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                        </svg>

                        {{ Math.abs(kankolekCM1Change).toFixed(1) }}%
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Total CM2 Card -->
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 border-0 shadow-sm position-relative card-stat">
          <div class="card-body">
            <h6 class="card-title mb-3 dashboard-card-title">Total CM2</h6>
            <div class="d-flex align-items-center">
              <h3 
                class="mb-0 me-2 text-dark fw-bold" 
              >
                <span class="peso-sign-gray">₱</span>{{ formatDashboardValue(totalCM2Amount) }}
              </h3>
            <span
                id="cm2-percentage"
                :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded px-2 py-1', getPercentageClass(totalCM2Change), 'bg-opacity-75']"
                :style="{ borderRadius: '4px', background: totalCM2Change === 0 ? '#F9F9F9' : (totalCM2Change > 0 ? 'var(--Success-Success-Light, #E8FFF3)' : 'var(--Danger-Danger-Light, #FFE8E8)') }"
                data-bs-toggle="tooltip" 
                data-bs-placement="right" 
                :title="formatTooltip(totalCM2PMMTD)"
            >
                <svg v-if="totalCM2Change > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                    <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                </svg>
                <svg v-else-if="totalCM2Change < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                    <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                </svg>
                {{ Math.abs(totalCM2Change).toFixed(1) }}%
              </span>
            </div>
            <p class="small mb-3 dashboard-date-text">{{ currentDateRange }}</p>
            
            <div class="border-top pt-3 mt-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium dashboard-label-text">E-Load</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold me-2 text-dark"
                  >
                    ₱{{ formatDashboardValue(eloadCM2Amount) }}
                  </span>
                <span
                    :class="['small fw-medium d-inline-flex align-items-center percentage-badge-small cursor-pointer', getPercentageClass(eloadCM2Change)]"
                    data-bs-toggle="tooltip" 
                    data-bs-placement="right" 
                    :title="formatTooltip(eloadCM2PMMTD)"
                >
                    <svg v-if="eloadCM2Change > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                        <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>

                    <svg v-else-if="eloadCM2Change < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                        <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 0Z" fill="#D9214E"/>
                    </svg>

                    {{ Math.abs(eloadCM2Change).toFixed(1) }}%
                </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium dashboard-label-text">Kankolek</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold me-2 text-dark"
                  >
                    ₱{{ formatDashboardValue(kankolekCM2Amount) }}
                  </span>
                <span
                    :class="['small fw-medium d-inline-flex align-items-center percentage-badge-small cursor-pointer', getPercentageClass(kankolekCM2Change)]"
                    data-bs-toggle="tooltip" 
                    data-bs-placement="right" 
                    :title="formatTooltip(kankolekCM2PMMTD)"
                >
                    <svg v-if="kankolekCM2Change > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">>
                        <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                        <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>

                    <svg v-else-if="kankolekCM2Change < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                        <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                        <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>

                    {{ Math.abs(kankolekCM2Change).toFixed(1) }}%
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Period View Table -->
    <div class="row">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless">
                <thead>
                  <tr class="border-bottom" style="border-bottom-width: 2px !important;">
                    <th class="period-view-header">Period View</th>
                    <th class="period-view-header"></th>
                    <th class="period-view-header text-end">Prior Month<br><small class="period-view-month">{{ periodViewPriorMonthLabel }}</small></th>
                    <th class="period-view-header text-end">PM MTD<br><small class="period-view-month">{{ periodViewPriorMonthDateRange }}</small></th>
                    <th class="period-view-header text-end">MTD<br><small class="period-view-month">{{ periodViewCurrentDateRange }}</small></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Revenue Section -->
                  <tr>
                    <td class="fw-bold text-dark">Revenue</td>
                    <td class="period-view-label">E-Load</td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadRevenuePM)">{{ formatNumber(eloadRevenuePM) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadRevenuePMMTD)">{{ formatNumber(eloadRevenuePMMTD) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadRevenueAmount)">{{ formatNumber(eloadRevenueAmount) }}</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="period-view-label">Kankolek</td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekRevenuePM)">{{ formatNumber(kankolekRevenuePM) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekRevenuePMMTD)">{{ formatNumber(kankolekRevenuePMMTD) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekRevenueAmount)">{{ formatNumber(kankolekRevenueAmount) }}</span></td>
                  </tr>
                  <tr class="border-bottom" style="border-bottom-width: 2px !important;" >
                    <td class="pb-3"></td>
                    <td class="period-view-total pb-3">Total</td>
                    <td class="text-end fw-bold pb-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalRevenuePM)">{{ formatNumber(totalRevenuePM) }}</span></td>
                    <td class="text-end fw-bold pb-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalRevenuePMMTD)">{{ formatNumber(totalRevenuePMMTD) }}</span></td>
                    <td class="text-end fw-bold pb-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalRevenueAmount)">{{ formatNumber(totalRevenueAmount) }}</span></td>
                  </tr>

                  <!-- CM1 Section -->
                  <tr>
                    <td class="fw-bold text-dark pt-3">CM1</td>
                    <td class="period-view-label pt-3">E-Load</td>
                    <td class="text-end pt-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadCM1PM)">{{ formatNumber(eloadCM1PM) }}</span></td>
                    <td class="text-end pt-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadCM1PMMTD)">{{ formatNumber(eloadCM1PMMTD) }}</span></td>
                    <td class="text-end pt-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadCM1Amount)">{{ formatNumber(eloadCM1Amount) }}</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="period-view-label">Kankolek</td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekCM1PM)">{{ formatNumber(kankolekCM1PM) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekCM1PMMTD)">{{ formatNumber(kankolekCM1PMMTD) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekCM1Amount)">{{ formatNumber(kankolekCM1Amount) }}</span></td>
                  </tr>
                  <tr class="border-bottom" style="border-bottom-width: 2px !important;" >
                    <td></td>
                    <td class="period-view-total">Total</td>
                    <td class="text-end fw-bold"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalCM1PM)">{{ formatNumber(totalCM1PM) }}</span></td>
                    <td class="text-end fw-bold"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalCM1PMMTD)">{{ formatNumber(totalCM1PMMTD) }}</span></td>
                    <td class="text-end fw-bold"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalCM1Amount)">{{ formatNumber(totalCM1Amount) }}</span></td>
                  </tr>
                  <tr class="border-bottom" style="border-bottom-width: 2px !important;" >
                    <td class="fw-bold text-dark pb-3">CM1 %</td>
                    <td class="pb-3"></td>
                    <td class="text-end pb-3"></td>
                    <td class="text-end fw-bold pb-3">{{ cm1PercentagePMMTD.toFixed(2) }}%</td>
                    <td class="text-end fw-bold pb-3">{{ cm1PercentageMTD.toFixed(2) }}%</td>
                  </tr>

                  <!-- CM2 Section -->
                  <tr>
                    <td class="fw-bold text-dark pt-3">CM2</td>
                    <td class="period-view-label pt-3">E-Load</td>
                    <td class="text-end pt-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadCM2PM)">{{ formatNumber(eloadCM2PM) }}</span></td>
                    <td class="text-end pt-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadCM2PMMTD)">{{ formatNumber(eloadCM2PMMTD) }}</span></td>
                    <td class="text-end pt-3"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(eloadCM2Amount)">{{ formatNumber(eloadCM2Amount) }}</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="period-view-label">Kankolek</td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekCM2PM)">{{ formatNumber(kankolekCM2PM) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekCM2PMMTD)">{{ formatNumber(kankolekCM2PMMTD) }}</span></td>
                    <td class="text-end"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(kankolekCM2Amount)">{{ formatNumber(kankolekCM2Amount) }}</span></td>
                  </tr>
                  <tr class="border-bottom" style="border-bottom-width: 2px !important;" >
                    <td></td>
                    <td class="period-view-total">Total</td>
                    <td class="text-end fw-bold"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalCM2PM)">{{ formatNumber(totalCM2PM) }}</span></td>
                    <td class="text-end fw-bold"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalCM2PMMTD)">{{ formatNumber(totalCM2PMMTD) }}</span></td>
                    <td class="text-end fw-bold"><span class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="left" :title="formatTableTooltip(totalCM2Amount)">{{ formatNumber(totalCM2Amount) }}</span></td>
                  </tr>
                  <tr>
                    <td class="fw-bold text-dark">CM2 %</td>
                    <td></td>
                    <td class="text-end"></td>
                    <td class="text-end fw-bold">{{ cm2PercentagePMMTD.toFixed(1) }}%</td>
                    <td class="text-end fw-bold">{{ cm2PercentageMTD.toFixed(1) }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

/* Dashboard Card Titles */
.dashboard-card-title {
  color: #7E8299;
  font-weight: 600;
  font-size: 14px;
}

.dashboard-date-text {
  color: #7E8299;
  font-weight: 600;
}

.dashboard-label-text {
  color: #A1A5B7;
  font-weight: 600;
}

.period-view-header {
  color: #7E8299;
  font-weight: 600;
}

.period-view-header small {
  color: #7E8299;
  font-weight: 600;
}

.period-view-label {
  color: #7E8299 !important;
  font-weight: 500;
}

.period-view-total {
  color: #7E8299 !important;
  font-weight: 700;
}

.table th {
  border-top: none;
  font-size: 0.85rem;
  padding: 0.75rem 0.5rem;
}

.table td {
  padding: 0.5rem;
  font-size: 0.875rem;
  vertical-align: middle;
  color: #3F4254;
  font-weight: 500;
}

.table-borderless td,
.table-borderless th {
  border: none;
}

.cursor-pointer {
  cursor: pointer;
}

.peso-sign-gray {
  color: #A1A5B7;
  vertical-align: super;
  font-size: 0.6em;
}

.text-neutral {
  color: #AFAFAF !important;
}

.period-view-month {
  color: #3F4254 !important; 
  font-weight: 600;
}

/* Card hover effect */
/* .card:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease-in-out;
} */

/* Ensure proper spacing for responsive design */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.8rem;
  }
  
  .card-body {
    padding: 1rem 0.75rem;
  }
  
  /* Stack cards on mobile */
  .col-lg-4 {
    margin-bottom: 1rem;
  }
}

/* Small mobile devices */
@media (max-width: 576px) {
  .table-responsive {
    font-size: 0.75rem;
  }
  
  .card-body {
    padding: 0.75rem 0.5rem;
  }
  
  h3 {
    font-size: 1.5rem;
  }
}

.coming-soon-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coming-soon-content {
  background: white;
  padding: 3rem 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.percentage-badge-small {
  min-width: unset !important;
  width: auto !important;
  justify-content: flex-start !important;
  margin-left: 0.2rem !important;
  font-size: 0.65rem !important;
  padding: 0.15rem 0.35rem !important;
  gap: 0.15rem !important;
}

</style>

<style>
.dashboard-tooltip-left .tooltip-inner {
  text-align: left !important;
}

.dashboard-tooltip-left .tooltip-inner .dashboard-tooltip-title {
  font-weight: 600;
  font-size: 0.875rem;
}
</style>
